const mobileMenu = () =>  {
	const toggleButton = document.querySelector('.m-Menu_Mobile');
	const subNavItems = document.querySelectorAll('.m-SubMenu a');
	const mobileMenu = document.querySelector('.g-PrimaryMenu_HeaderLinks');

	const isMenuOpen = (element) => {
		return element.classList.contains('js-open');
	}

	var bindElements = () => {
		//BIND MENU 
		if (toggleButton) {
			toggleButton.addEventListener('click', () => {
				return isMenuOpen(toggleButton) ? menuClose() : menuOpen();
			})
		}

		Array.from(subNavItems).forEach( (item) => {
			// console.log(item);
			item.addEventListener('focus', (e) => {
				item.parentNode.parentNode.parentNode.classList.add('js-appear');
				item.parentNode.parentNode.parentNode.parentNode.querySelector('.m-MenuItem_Link').classList.add('js-focus');
			})
		})

		Array.from(subNavItems).forEach( (item) => {
			// console.log(item);
			item.addEventListener('blur', (e) => {
				item.parentNode.parentNode.parentNode.classList.remove('js-appear');
				item.parentNode.parentNode.parentNode.parentNode.querySelector('.m-MenuItem_Link').classList.remove('js-focus');
			})
		})


	}

	var menuOpen = () => {
		toggleButton.classList.add('js-open');
		mobileMenu.classList.add('js-open');
		document.querySelector('html').classList.add('js-menu-open');
	}
	
	var menuClose = () => {
		toggleButton.classList.remove('js-open');
		mobileMenu.classList.remove('js-open');
		document.querySelector('html').classList.remove('js-menu-open');
	}


	// Self init of menu
	bindElements();
}

mobileMenu(); 